import { render, staticRenderFns } from "./MExtra.vue?vue&type=template&id=363443a3&scoped=true&"
import script from "./MExtra.vue?vue&type=script&lang=js&"
export * from "./MExtra.vue?vue&type=script&lang=js&"
import style0 from "./MExtra.vue?vue&type=style&index=0&id=363443a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363443a3",
  null
  
)

export default component.exports